import { render } from "./banker1.vue?vue&type=template&id=1d3afdc3"
import script from "./banker1.vue?vue&type=script&lang=js"
export * from "./banker1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__